// import fbIcon from "assets/img/social/fb_icon.png";
// import twitterIcon from "assets/img/social/twitter_icon.png";
// import gPlusIcon from "assets/img/social/g_plus_icon.png";
// import linkedInIcon from "assets/img/social/linked_in_icon.png";
// import redditIcon from "assets/img/social/reddit_icon.png";
// import bloggerIcon from "assets/img/social/blogger_icon.png";
// import youtubeIcon from "assets/img/social/youtube_icon.png";
//
// import instagramIcon from "assets/img/social/instagram_icon.png";
// import tripAdvisorIcon from "assets/img/social/trip_advisor_icon.png";
// import flickerIcon from "assets/img/social/flicker_icon.png";

import {
  FacebookShareButton,
  TwitterShareButton,
  // GooglePlusShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  RedditShareButton,
  TumblrShareButton,
  // PinterestShareButton,

  FacebookIcon,
  TwitterIcon,
  // GooglePlusIcon,
  LinkedinIcon,
  // PinterestIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
} from 'react-share';

export const socialButtons = {
  facebook: {
    Button: FacebookShareButton,
    Icon: FacebookIcon,
    TitleField: 'quote',
  },
  twitter: {
    Button: TwitterShareButton,
    Icon: TwitterIcon,
    TitleField: 'title',
  },
  // googlePlus: {
  //   Button: GooglePlusShareButton,
  //   Icon: GooglePlusIcon,
  //   TitleField: '',
  // },
  linkedIn: {
    Button: LinkedinShareButton,
    Icon: LinkedinIcon,
    TitleField: 'title',
    // windowWidth={750}
    // windowHeight={600}
  },
  whatsapp: {
    Button: WhatsappShareButton,
    Icon: WhatsappIcon,
    TitleField: 'title',
  },
  telegram: {
    Button: TelegramShareButton,
    Icon: TelegramIcon,
    TitleField: 'title',
  },
  reddit: {
    Button: RedditShareButton,
    Icon: RedditIcon,
    TitleField: 'title',
    // windowWidth={660}
    // windowHeight={460}
  },
  tumblr: {
    Button: TumblrShareButton,
    Icon: TumblrIcon,
  },

  // TODO fix this?????

  // pintrest: {
  //   Button: PinterestShareButton,
  //   Icon: PinterestIcon,
  //   TitleField: '',
  //   // url={String(window.location)}
  //   // media={`${String(window.location)}/${exampleImage}`}
  //   // windowWidth={1000}
  //   // windowHeight={730}
  // },
};

export default {socialButtons};



// WEBPACK FOOTER //
// ./src/views/PollTemplate/socialIconsHelper.js